import { gql } from "@apollo/client";

export const ALL_PAGES = gql`
  query AllPagesForListing(
    $page: Int!
    $perPage: Int!
    $filter: PageFilter
  ) {
    allPages(
      page: $page
      perPage: $perPage
      sortField: "updatedAt"
      sortOrder: "DESC"
      filter: $filter
    ) {
      id
      tenantId
      slug
      title
      status
      isHome
      showInNav
      updatedAt
      createdAt
    }
    _allPagesMeta(filter: $filter) {
      count
    }
  }
`;

export const PAGE_FOR_EDIT = gql`
  query PageForEdit($id: String!) {
    Page(id: $id) {
      id
      tenantId
      slug
      title
      description
      ogImageUrl
      publishedContent
      draftContent
      isHome
      showInNav
      attribution
      status
      createdAt
      updatedAt
    }
  }
`;
